import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'enableAppleLogin',
  initialState: true,
  reducers: {
    setEnableAppleLogin: (_, action: PayloadAction<boolean>) => {
      return action.payload;
    },
  },
});

export const { setEnableAppleLogin } = slice.actions;
export default slice.reducer;
